import { apiConfig } from 'config';
import { swManagerRequest } from './utils';

export const getAllBeamTables = () => {
  const url = apiConfig.swManagerGetAllBeamTables();
  const options = { method: 'GET' };

  return swManagerRequest(url, options);
};
